import { AfterViewInit, Component, ViewChild } from '@angular/core';
import { BaseComponent } from '@ids-components';
import { REMOTE_FEATURE_LABELS } from '@ids-constants';
import { TargetDeviceService } from '@ids-services';
import { FormBuilderComponent } from '@microsec/components';
import { SAVE_CHANGES_LABEL } from '@microsec/constants';
import { FormItem } from '@microsec/models';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { finalize } from 'rxjs';

const FORM_PARAMS = {
  FREQUENCY: 'custom_properties_frequency',
};

@Component({
  selector: 'app-microagent-config-assessment-form',
  templateUrl: './microagent-config-assessment-form.component.html',
  styleUrls: ['./microagent-config-assessment-form.component.scss'],
  imports: [FormBuilderComponent],
})
export class MicroagentConfigAssessmentFormComponent extends BaseComponent implements AfterViewInit {
  deviceId: any = null;

  configuration: any = null;

  feature: any = null;

  fields: FormItem[] = [];

  @ViewChild('fb') form!: FormBuilderComponent;

  FORM_PARAMS = FORM_PARAMS;

  SAVE_CHANGES_LABEL = SAVE_CHANGES_LABEL;

  constructor(
    private targetDeviceService: TargetDeviceService,
    public dialogConfig: DynamicDialogConfig,
  ) {
    super();
  }

  async ngAfterViewInit() {
    await this.prepareConfigs();
    this.deviceId = this.dialogConfig?.data?.deviceId;
    this.configuration = this.dialogConfig?.data?.configuration;
    this.feature = this.dialogConfig?.data?.feature;
    this.initForm();
  }

  initForm() {
    const fields: FormItem[] = [
      Object.assign(new FormItem(), {
        label: 'On-Device Assessment',
        labelStyleClass: 'font-bold',
        field: 'text',
      } as FormItem),
      Object.assign(new FormItem(), {
        name: FORM_PARAMS.FREQUENCY,
        label: 'Frequency (mins)',
        required: true,
        field: 'number',
        fieldInfo: 'How often the on-device assessments are performed',
        minValue: 0,
        defaultValue: 10,
      } as FormItem),
    ];
    this.fields = fields;
    this.form?.patchValue({
      ...this.configuration?.[this.feature],
    });
  }

  onSubmit(closeDialog: () => void) {
    this.form.isLoading = true;
    const formData = this.form.getRawValue();

    const payload = {
      configuration: {
        [this.feature]: {
          ...formData,
        },
      },
    };

    this.targetDeviceService
      .updateDeviceConfiguration(this.deviceId, payload)
      .pipe(
        finalize(() => {
          this.form.isLoading = false;
        }),
      )
      .subscribe({
        next: () => {
          this.showSuccessMessage(`${REMOTE_FEATURE_LABELS[this.feature] || this.feature} Configuration Updated Successfully`);
          closeDialog();
        },
        error: (error) => {
          this.showErrorMessage(error);
        },
      });
  }
}
